export const ACTION_BADGE = {
  ASSET_ADDED:   { bg: 'success', label: 'Added' },
  ASSET_UPDATED: { bg: 'warning', label: 'Updated' },
  ASSET_DELETED: { bg: 'danger',  label: 'Deleted' },
  FIELD_UPDATE:  { bg: 'info',    label: 'Field' },
  PHOTO_UPDATE:  { bg: 'primary', label: 'Photo' },
};

export function formatDateTime(value) {
  if (!value) return '—';
  return new Date(value).toLocaleString();
}

export function formatChange(oldValue, newValue) {
  const old  = oldValue != null ? String(oldValue) : '—';
  const next = newValue != null ? String(newValue) : '—';
  return `${old} → ${next}`;
}

/**
 * Try to parse a value as a JSON array of photo URLs.
 * Returns the array if valid and non-empty; null otherwise.
 */
export function parsePhotoUrls(value) {
  if (!value) return null;
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed) && parsed.length > 0) return parsed;
  } catch (_) {}
  return null;
}

/**
 * Build a flat { fieldId → label } map from the runtime assetSchema loaded in
 * RootContext. Iterates every section → asset type → fields array and records
 * the field's `name` (or title-cased `id` when no name is provided).
 */
export function buildAssetFieldLabelMap(assetSchema) {
  const map = {};
  if (!assetSchema || typeof assetSchema !== 'object') return map;

  function titleCase(str) {
    return String(str)
      .split('_')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }

  Object.values(assetSchema).forEach(section => {
    if (!Array.isArray(section)) return;
    section.forEach(assetType => {
      if (!Array.isArray(assetType.fields)) return;
      assetType.fields.forEach(field => {
        if (!field.id) return;
        map[field.id] = field.name || titleCase(field.id);
      });
    });
  });

  map.photos = 'Photos';
  return map;
}
